import DashboardLayout from '../layouts/DashboardLayout'

export const transactionHistoryMenu = {
  path: '/partner/transaction-history',
  component: DashboardLayout,
  name: 'Transaction History',
  redirect: '/partner/transaction-history',
  children: [
    {
      path: '/',
      name: 'Transaction History',
      component: () => import (/* webpackChunkName: "about" */'../pages/history-transaction-partner/TransactionHistory'),
      meta: {
        requiresAuth: true,
        roles: 'all',
        breadcrumb: [{
          title: 'Giao dịch'
        }]
      },
    }
  ],
}